const DEFAULT_AI_TICKET_TEMPLATE_DIALOG_VALUES = {
  name: '',
  summary: ''
};

export default DEFAULT_AI_TICKET_TEMPLATE_DIALOG_VALUES;
